module.exports = __webpack_public_path__ + "img/profile-fill.cfe8f5fb.svg";